import React from "react";
import { Chip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { EvidenceStatus } from "../../utils/enums";

const FileValidationStatusChip = ({ validationStatus }) => {
  switch (validationStatus.status) {
    case EvidenceStatus?.VALID:
      return (
        <Chip
          icon={<CheckCircleIcon fontSize="small" />}
          label={validationStatus.message}
          sx={{
            backgroundColor: "#E8FBF3",
            color: "#057F28",
            borderRadius: 1,
            fontWeight: 600,
            fontSize: "0.75rem",
            border: "none",
            "& .MuiChip-icon": {
              color: "#057F28",
            },
          }}
        />
      );
    case EvidenceStatus?.PROCESSING:
      return (
        <Chip
          icon={<HourglassEmptyIcon fontSize="small" />}
          label={validationStatus.message}
          sx={{
            backgroundColor: "#FFF4E5",
            color: "#FF8800",
            borderRadius: 1,
            fontWeight: 600,
            fontSize: "0.75rem",
            border: "none",
            "& .MuiChip-icon": {
              color: "#FF8800",
            },
          }}
        />
      );
    case EvidenceStatus?.INVALID:
    default:
      return (
        <Chip
          icon={<ErrorIcon fontSize="small" />}
          label={validationStatus.message}
          sx={{
            backgroundColor: "#FEEBEB",
            color: "#C71414",
            borderRadius: 1,
            fontWeight: 600,
            fontSize: "0.75rem",
            border: "none",
            "& .MuiChip-icon": {
              color: "#C71414",
            },
          }}
        />
      );
  }
};

export default FileValidationStatusChip;
